"use strict";

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable max-classes-per-file */
var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var isUndefined = require('lodash/isUndefined');

var moment = require('moment-timezone');

var setShippingOptions = require('./setShippingOptions');

var parseOrderDetails = require('./parseOrderDetails');

var parseTags = require('./parseTags');

var setAdvancedOptions = require('./setAdvancedOptions');

var LA = 'America/Los_Angeles';
var NY = 'America/New_York';

var Address = function Address() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, Address);

  this.name = params.name || null;
  this.company = params.company || null;
  this.street1 = params.street1 || null;
  this.street2 = params.street2 || null;
  this.street3 = params.street3 || null;
  this.city = params.city || null;
  this.state = params.state || null;
  this.postalCode = params.postalCode || null;
  this.country = params.country && params.country.slice(0, 2).toUpperCase() || 'US';
  this.phone = params.phone || null;
  this.residential = isUndefined(params.residential) ? null : parseBoolean(params.residential);
  this.addressVerified = params.addressVerified || 'Address not yet validated';
}; // ship station order dates are in PST/PDT


var shipStationDateFormat = 'YYYY-MM-DD HH:mm:ss';

function parseDate() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return moment(str, shipStationDateFormat, LA).format(shipStationDateFormat);
}

var ShipStationOrder = /*#__PURE__*/function () {
  function ShipStationOrder() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ShipStationOrder);

    this.orderId = params.orderId || null; // read-only

    this.orderNumber = params.orderNumber ? params.orderNumber.toString() : null;
    this.orderKey = params.orderKey ? params.orderKey.toString() : null;
    this.orderDate = params.orderDate ? parseDate(params.orderDate) : null;
    this.createDate = params.createDate ? parseDate(params.createDate) : null; // read-only

    this.modifyDate = parseDate(params.modifyDate); // read-only

    this.paymentDate = params.paymentDate ? parseDate(params.paymentDate) : null;
    this.shipByDate = params.shipByDate ? parseDate(params.shipByDate) : null;
    this.orderStatus = params.orderStatus || null;
    this.customerId = params.customerId || null; // read-only

    this.customerUsername = params.customerUsername || null;
    this.customerEmail = params.customerEmail || null;
    this.billTo = new Address(params.billTo);
    this.shipTo = new Address(params.shipTo);
    this.items = params.items || null;
    this.amountPaid = params.amountPaid || null;
    this.shippingAmount = params.shippingAmount || null;
    this.customerNotes = params.customerNotes || null;
    this.internalNotes = params.internalNotes || null;
    this.paymentMethod = params.paymentMethod || null;
    this.requestedShippingService = params.requestedShippingService || null;
    this.carrierCode = params.carrierCode || null;
    this.serviceCode = params.serviceCode || null;
    this.packageCode = params.packageCode || null;
    this.confirmation = params.confirmation || null;
    this.shipDate = params.shipDate ? parseDate(params.shipDate) : null;
    this.holdUntilDate = params.holdUntilDate ? parseDate(params.holdUntilDate) : null;
    this.weight = params.weight || null;
    this.dimensions = params.dimensions || null;
    this.insuranceOptions = params.insuranceOptions || null;
    this.internationalOptions = params.internationalOptions || null;
    this.advancedOptions = params.advancedOptions || null;
    this.tagIds = params.tagIds || null;
    this.userId = params.userId || null; // read-only

    this.externallyFulfilled = params.externallyFulfilled || null; // read-only

    this.externallyFulfilledBy = params.externallyFulfilledBy || null; // read-only
  }

  _createClass(ShipStationOrder, null, [{
    key: "makeShipStationOrder",
    value: function makeShipStationOrder(shipment, orderNumber, options) {
      var billTo = {
        name: "".concat(shipment.firstname, " ").concat(shipment.lastname)
      }; // required

      var shipTo = {
        name: "".concat(shipment.firstname, " ").concat(shipment.lastname),
        street1: shipment.address1,
        street2: shipment.address2,
        // company: `ref: ${} ${}`, // TODO: Make this the customer name if not shipping to customer
        city: shipment.city,
        state: shipment.state,
        postalCode: shipment.zip,
        country: shipment.country,
        phone: shipment.telephone
      }; // required

      var _setShippingOptions = setShippingOptions(shipment, options),
          carrierCode = _setShippingOptions.carrierCode,
          serviceCode = _setShippingOptions.serviceCode,
          packageCode = _setShippingOptions.packageCode,
          confirmation = _setShippingOptions.confirmation;

      var shipByDate = shipment.ship_by_date;
      return new ShipStationOrder({
        orderNumber: orderNumber,
        // required
        orderKey: "".concat(shipment.id, "-").concat(moment().format('x')),
        orderDate: shipment.order_date ? moment(shipment.order_date, NY).tz(LA) : moment().tz(LA),
        // required
        paymentDate: shipment.order_date || '',
        orderStatus: shipment.orderStatus || 'awaiting_shipment',
        // required
        customerUsername: shipment.email || '',
        customerEmail: shipment.email || '',
        billTo: billTo,
        shipTo: shipTo,
        shipByDate: shipByDate,
        items: parseOrderDetails(shipment, options),
        amountPaid: shipment.total_price || 0,
        shippingAmount: shipment.shipping_amount || '0',
        internalNotes: shipment.notes.join(' -- ') || '',
        paymentMethod: shipment.payment_type || null,
        requestedShippingService: shipment.service,
        carrierCode: carrierCode,
        serviceCode: serviceCode,
        packageCode: packageCode,
        confirmation: confirmation,
        tagIds: parseTags(shipment, options) || [],
        advancedOptions: setAdvancedOptions(shipment, options)
      });
    }
  }]);

  return ShipStationOrder;
}();

module.exports = ShipStationOrder;